import './LanguageInfo.scss';

const LanguageInfo = function(props) {
	if (!props.language) {
		return (
			<p className="language-info">{window?.t?.NO_LANGUAGE} <a href="#" onClick={props.toggleSettingsCallback}>{window?.t?.NO_LANGUAGE_LINK_TEXT}</a></p>
		);
	}

	let slug = props.location ? 'COUNTRY_' + props.location.replaceAll('-', '').replaceAll(' ', '').replaceAll("'", '').toUpperCase() : '';
	let locationName = window?.t[slug] || props.location;

	return (
		<p className="language-info">
			<span>{window?.t?.CURRENT_LANG}: <b>{window?.t[`LANG_${props.language.t}`]}</b></span>
			<span>{window?.t?.CURRENT_COUNTRY}: <b>{locationName}</b></span>
			<span className="hint">{window?.t?.CHANGE_LANG_COUNTRY} <a href="#" onClick={props.toggleSettingsCallback}>{window?.t?.CHANGE_LANG_COUNTRY_LINK_TEXT}</a></span><br />
		</p>
	)
}

export default LanguageInfo;